import { render } from "./PreloaderDialog.vue?vue&type=template&id=11f6153e"
import script from "./PreloaderDialog.vue?vue&type=script&lang=js"
export * from "./PreloaderDialog.vue?vue&type=script&lang=js"

import "./PreloaderDialog.vue?vue&type=style&index=0&id=11f6153e&lang=scss"
script.render = render

export default script